<template>
  <b-container fluid>
    <base-back-to-previous-button class="mb-4"></base-back-to-previous-button>

    <CardProfile :user="user" :editable="false" class="mb-4" />
  </b-container>
</template>

<script>
import Learner from '@/models/Learner';
import CardProfile from '@/views/Profile/components/CardProfile.vue';
import BaseBackToPreviousButton from '@/components/base-components/BaseBackToPreviousButton.vue';

export default {
  components: {
    CardProfile,
    BaseBackToPreviousButton
  },

  data() {
    return {
      user: {}
    };
  },

  computed: {
    learnerId() {
      return parseInt(this.$route.params.learnerId);
    }
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      try {
        await Learner.api().findOneLearner(this.learnerId);

        this.user = Learner.query().whereId(this.learnerId).first();
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style></style>
